import { createAction, handleActions } from 'redux-actions';
import { takeLatest, call } from 'redux-saga/effects';
import * as userAPI from '../../lib/api/userapi';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';

/**
 * 사용자 상태 저장 리덕스 모듈 
 */

/**
 * 액션 타입 정의 
 */

// 클립 브랜드 저장
const SET_CLIP_BRAND_ID = 'userBrand/SET_CLIP_BRAND_ID';
// 노 브랜드 요청 저장
const SET_NO_BRAND_ID = 'userBrand/SET_NO_BRAND_ID';
// 좋아요 브랜드
const [BRAND, BRAND_SUCCESS, BRAND_FAILURE] = createRequestActionTypes(
    'user/brand',
);
// 브랜드 오픈 요청
const [NOBRAND, NOBRAND_SUCCESS, NOBRAND_FAILURE] = createRequestActionTypes(
    'user/nobrand',
);


export const setClipBrandIdAction = createAction(SET_CLIP_BRAND_ID);
export const setNoBrandIdAction = createAction(SET_NO_BRAND_ID);

export const brandAction = createAction(BRAND, (email) => {
    return { email }
});
export const nobrandAction = createAction(NOBRAND, (email) => {
    return { email }
});

/**
 * Networ 통신 : Saga Lib 사용 
 */
const brandSaga = createRequestSaga(BRAND, userAPI.brand);
const nobrandSaga = createRequestSaga(NOBRAND, userAPI.nobrand);

export function* userBrandSaga() {
    yield takeLatest(BRAND, brandSaga);
    yield takeLatest(NOBRAND, nobrandSaga);
}


/**
 * 리덕스 모듈 초기값 
 */
const initialState = {
    clipBrandIds: null, //좋아요 브랜드
    noBrandIds: null,   //브랜드 오픈 요청
    error: null,

};

/**
 * 리덕스 액션 연결 
 */
const userBrandReducer = handleActions(
    {
        [SET_CLIP_BRAND_ID]: (state, { payload: clipBrandIds }) => ({
            ...state,
            clipBrandIds: clipBrandIds,
        }),
        [SET_NO_BRAND_ID]: (state, { payload: noBrandIds }) => ({
            ...state,
            noBrandIds: noBrandIds,
        }),
        [BRAND_SUCCESS]: (state, { payload: clipBrandIds }) => {

            //console.log("BRAND_SUCCESS : " + JSON.stringify(clipBrandIds));
            let data = [];
            if (clipBrandIds !== null & clipBrandIds.length > 0) {
                clipBrandIds.forEach(element => {
                    data.push(element.brnd_id)

                });
            }
            //console.log("BRAND_SUCCESS : " + data);
            return {
                ...state,
                clipBrandIds: data,
            }

        },
        [BRAND_FAILURE]: (state, { payload: error }) => {

            // console.log("BRAND_FAILURE !!!")

            return {
                ...state,
                error: error
            }
        },
        [NOBRAND_SUCCESS]: (state, { payload: noBrandIds }) => {
            let data = [];
            if (noBrandIds !== null & noBrandIds.length > 0) {
                noBrandIds.forEach(element => {
                    data.push(element.no_brnd_id)

                });
            }
            return {
                ...state,
                noBrandIds: data,
            }

        },
        [NOBRAND_FAILURE]: (state, { payload: error }) => {

            // console.log("NOBRAND_FAILURE !!!")

            return {
                ...state,
                error: error
            }
        },
    },
    initialState,
);

export default userBrandReducer;